import React from 'react';
import clsx from 'clsx';
import styles from '../FundingHistory.module.scss';
import FundingTableRow from './FundingTableRow';
import SummaryRow from './SummaryRow';
import EmptyDataRow from './EmptyDataRow';

interface FundingTableProps {
    headers: Array<{ id: string; label: string }>;
    fundingData: any[];
    debentureData: any[];
    totalFundingAmount: number;
    totalDebentureAmount: number;
    isPDFReport: boolean;
    showFundingData: boolean;
    showDebentureData: boolean;
    taskTrackerStatus: string;
    onDownload: (docId: string, rowIndex: number) => void;
    fileDownloadingIndex: number | null;
}

function FundingTable({
    headers,
    fundingData,
    debentureData,
    totalFundingAmount,
    totalDebentureAmount,
    isPDFReport,
    showFundingData,
    showDebentureData,
    taskTrackerStatus,
    onDownload,
    fileDownloadingIndex,
}: FundingTableProps) {
    return (
        <div className={styles.table}>
            <div className={styles.tableHeader}>
                {headers.map((header) => (
                    <div
                        className={clsx(styles.headerItem, {
                            [styles.alignRight]: ['fundingAmount'].includes(header.id),
                        })}
                        key={header.id}
                    >
                        {header.label}
                    </div>
                ))}
            </div>
            <div className={styles.tableBody}>
                {/* No Data Message - only show if taskTrackerStatus is not FAILED */}
                {!showFundingData && !showDebentureData && taskTrackerStatus !== 'FAILED' && (
                    <EmptyDataRow message="No funding history found on MCA" />
                )}

                {/* Funding History Data */}
                {showFundingData &&
                    fundingData?.map((item, rowIndex) => (
                        <FundingTableRow
                            key={`funding-${rowIndex}`}
                            data={item}
                            headers={headers}
                            rowIndex={rowIndex}
                            isPDFReport={isPDFReport}
                            onDownload={onDownload}
                            isDownloading={fileDownloadingIndex === rowIndex}
                        />
                    ))}

                {/* Total Funding Raised Summary Row */}
                {showFundingData && <SummaryRow title="Total Funding Raised" amount={totalFundingAmount} isPDFReport={isPDFReport} />}

                {/* Debenture History Data */}
                {showDebentureData &&
                    debentureData?.map((item, rowIndex) => (
                        <FundingTableRow
                            key={`debenture-${rowIndex}`}
                            data={item}
                            headers={headers}
                            rowIndex={rowIndex}
                            isPDFReport={isPDFReport}
                            onDownload={onDownload}
                            isDownloading={fileDownloadingIndex === rowIndex}
                        />
                    ))}

                {/* Total Debentures Issued Summary Row */}
                {showDebentureData && (
                    <SummaryRow title="Total Debentures Issued" amount={totalDebentureAmount} isPDFReport={isPDFReport} />
                )}
            </div>
        </div>
    );
}

export default FundingTable;
